import { lazy } from "react";
import Loadable from "../components/Loadable";
import { authRoles } from "../auth/authRoles";

const EventDetailPage = Loadable(lazy(() => import("../views/events/eventDetails")));
const EventFormPage = Loadable(lazy(() => import("../views/events/eventForm")));
//const EventsList = Loadable(lazy(() => import("../views/events")));
const EventsList = Loadable(lazy(() => import("../views/pages/UpComingEvents/index.jsx")));
const Enrollments = Loadable(lazy(() => import("../views/pages/Enrollments/index.jsx")));
//const MyEvents = Loadable(lazy(() => import("../views/events/MyEvents")));
const MyEvents = Loadable(lazy(() => import("../views/pages/MyEvents/index.jsx")))
const MyOrders = Loadable(lazy(() => import("../views/events/MyOrders")));
const ReportsPage = Loadable(lazy(() => import("../views/events/reports/index")));
const TransactionApprovalListPage = Loadable(lazy(() => import("../views/members/payments/tansactionApproval")));
const EventRegistrationPayment = Loadable(lazy(() => import("../views/members/payments/makePayment")));
const SelfRegisterThroughUrl = Loadable(lazy(() => import("../views/events/registerThroughUrl")));
const NewReportPage = Loadable(
  lazy(() => import("../views/events/reports/newReoprtUI"))
);
const BulkRegistrationPage = Loadable(lazy(() => import("../views/events/eventDetails/bulkRegistration/bulkRegistration")))
const RoomSharingUI = Loadable(
  lazy(() => import("../views/presentation/RoomSharing/roomSharingUI"))
);
const EventDashboard = Loadable(lazy(() => import("../views/events/eventDashboard")));

//EDIT POPUP to WEB PAGE
const EditTicketEventReportPage = Loadable(
  lazy(() => import("../views/events/reports/editReport/editTicketEventReport"))
);

const eventRoutes = [
  { path: "/events", element: <EventsList />, auth: authRoles.admin },
  { path: "/enrollments", element: <Enrollments /> },
  { path: "/my-events", element: <MyEvents /> },
  { path: "/my-orders", element: <MyOrders /> },
  { path: "/events/:id", element: <EventDetailPage />, auth: authRoles.admin },
  { path: "/events/create", element: <EventFormPage />, auth: authRoles.admin },
  { path: "/events/update", element: <EventFormPage />, auth: authRoles.admin },
  { path: "/events/bulk-registration", element: <BulkRegistrationPage />, auth: authRoles.admin },
  { path: "/events/review-payments/:id", element: <TransactionApprovalListPage />, auth: authRoles.admin },
  { path: "/events/reports/:id/:userName", element: <ReportsPage />, auth: authRoles.admin },
  { path: "/events/reports/:id", element: <ReportsPage />, auth: authRoles.admin },
  { path: "/payment/:event_id?/:user_id?", element: <EventRegistrationPayment /> },
  { path: "/events/:id", element: <SelfRegisterThroughUrl />, auth: authRoles.admin },
  {
    path: "/events/report/newReport",
    element: <NewReportPage />,
    auth: authRoles.admin,
  },
  // dashboard - event specific
  {
    path: "/event-dashboard/:event_code",
    element: <EventDashboard />,
    auth: authRoles.admin,
  },
  //room-sharing-ui
  {
    path: "/events/room-sharing/:event_code",
    element: <RoomSharingUI />,
    auth: authRoles.admin,
  },
  //edit popup to web page
  {
    path: "/events/reports/:id/:userName/update",
    element: <EditTicketEventReportPage />,
    auth: authRoles.admin,
  },

];

export default eventRoutes;
